export const UPDATE_STORE_MAPPING_BEGIN = 'UPDATE_STORE_MAPPING_BEGIN'
export const UPDATE_STORE_MAPPING_SUCCESS = 'UPDATE_STORE_MAPPING_SUCCESS'
export const UPDATE_STORE_MAPPING_ERROR = 'UPDATE_STORE_MAPPING_ERROR'
